import {baseURL} from '@/infrastructure/Configuration'
import SessionApi from "@/mixins/Services/SessionApi";
import Utils from "@/mixins/Utils";

const GROUP = 'group';
const NODE = 'node';
const AVALAIBLES = 'avalaibles';
const ADMIN = 'admin';

export default {
    mixins: [SessionApi, Utils],
    methods: {
        async getGroups() {
            const url = `${baseURL}${GROUP}`
            const response = await this.httpSession().get(url)
            console.debug('[GROUPS][getGroups] list:', response.data)
            return response.data;
        },
        async getNodesByGroup(groupId) {
            const url = `${baseURL}${GROUP}/${NODE}/${groupId}`
            const response = await this.httpSession().get(url, {params: {groupId}})
            console.debug('[GROUPS][getNodeByGroup] list:', response.data)
            return response.data;
        },
        async getNodeNamesByGroupAndCompany() {
            const url = `${baseURL}${GROUP}/${NODE}`
            const response = await this.httpSession().get(url)
            console.debug('[GROUPS][getNodeNamesByGroupAndCompany] list:', response.data)
            return response.data;
        },
        async getAvalaibleNodesForGroup(groupId) {
            const url = `${baseURL}${GROUP}/${NODE}/${AVALAIBLES}/${groupId}`
            const response = await this.httpSession().get(url, {params: {groupId}})
            console.debug('[GROUPS][getAvalaibleNodesForGroup] list:', response.data)
            return response.data;
        },
        async getAvalaibleNodes() {
            const url = `${baseURL}${GROUP}/${NODE}/${AVALAIBLES}`
            const response = await this.httpSession().get(url)
            console.debug('[GROUPS][getAvalaibleNodes] list:', response.data)
            return response.data;
        },
        async createGroup(data) {
            console.debug('[GROUPS][createGroup] request data', data)
            const url = `${baseURL}${ADMIN}/${GROUP}`
            const response = await this.httpSession().post(url, {...data})
            console.debug('[GROUPS][createGroup] RESPONSE', response.data)
            return response.data
        },
        async updateGroup(data) {
            console.debug('[GROUPS][updateGroup] request data', data)
            const url = `${baseURL}${ADMIN}/${GROUP}/${data.groupId}`
            const response = await this.httpSession().put(url, {...data})
            console.debug('[GROUPS][updateGroup] RESPONSE', response.data)
            return response.data
        },
        async deleteGroup(groupId) {
            console.debug('[GROUPS][deleteGroup] request groupId', groupId)
            const url = `${baseURL}${ADMIN}/${GROUP}/${groupId}`
            const response = await this.httpSession().delete(url)
            console.debug('[GROUPS][deleteGroup] RESPONSE', response.data)
            return response.data
        }
    },
};
